import { render, staticRenderFns } from "./BookingServiceAvailability.vue?vue&type=template&id=50d7fcf1&scoped=true"
import script from "./BookingServiceAvailability.vue?vue&type=script&lang=ts"
export * from "./BookingServiceAvailability.vue?vue&type=script&lang=ts"
import style0 from "./BookingServiceAvailability.vue?vue&type=style&index=0&id=50d7fcf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7fcf1",
  null
  
)

export default component.exports